export enum SelectedUserStatusesEnum {
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
  NOT_FOUND = 'not-found',
}
